import React, { Component ,lazy,Suspense} from 'react';
import { Layout,BackTop} from 'antd';
import {
  Routes,
  Route,
  useLocation,
} from 'react-router-dom'

import './App.css' 

import NotFound from './NotFound';
import Loading from './components/Loading';
import Footer from './components/Footer';
import Header from './components/Header';
import Home from './contents/Home';
import { PayPalScriptProvider } from '@paypal/react-paypal-js';
const About= lazy(()=> import('./contents/About'))
const Membership= lazy(()=> import('./contents/Membership'))
const Membershipreg= lazy(()=> import('./contents/Membershipreg'))
const MCheckout=lazy(()=> import('./contents/MCheckout'))
const News=lazy(()=> import('./contents/News'))
const Contact=lazy(()=> import('./contents/Contact'))
const ICCSICheckout=lazy(()=> import('./contents/ICCSICheckout'))
const ICCSIREG=lazy(()=> import('./contents/ICCSIreg'))
const AgistAdmin=lazy(()=> import('./contents/AgistAdmin'))
const { Content} = Layout;

function AppLayout() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/agistadmin');

  return (
    <div>
      <PayPalScriptProvider options={{"clientId":"AUI9Am98jX9Zx938aMKooTPrLVeOY9ICfid6ubytQkUbR2E5lZSUGq_kx4sr9F_6MMUoVKuzbb4IrGMv"}}>  {/* 生产环境 */}
{/* <PayPalScriptProvider options={{"clientId":"ATgZQJB0BCZN3lm7s7gX-jXOOBgV2_1iJS9pexML8uxDab8ibwnOVY6i2iKHmnWwv0nswwFwpiRTfDud"}}>  {/* 沙盒环境 */}
      <Layout style={{ minHeight: '100vh' }}>
        <Layout className="site-layout">
          {!isAdmin && <Header />}
          <div className={isAdmin ? 'admin-middle' : 'middle'}>
          <Content  style={{ margin: isAdmin ? 0 : ' 16px 16px' , backgroundColor: isAdmin ? '#f5f7fb' : '#ffffff'}}>
          <BackTop />
          <Suspense fallback={<Loading/>}><div className={isAdmin ? 'admin-middle2' : 'middle2'}>

          
          <Routes>
                <Route index element = {<Home/>}/> 
                <Route path="home"  element = {<Home/>}/> 
                <Route path="about"  element = {<About/>}/> 
                <Route path="membership"  element = {<Membership/>}/> 
                <Route path="membershipreg"  element = {<Membershipreg/>}/> 
                <Route path="membercheckout/:data/:money"  element = {<MCheckout/>}/> 
                <Route path="iccsicheckout"  element = {<ICCSICheckout/>}/> 
                <Route path="iccsireg"  element = {<ICCSIREG/>}/>
                <Route path="agistadmin/*"  element = {<AgistAdmin/>}/>
                <Route path="news/*"  element = {<News/>}/> 
                <Route path="contact"  element = {<Contact/>}/> 
                <Route path="*" element={<NotFound/>} />
          </Routes>
          </div>
          </Suspense>
          </Content>
          </div>
          {!isAdmin && <Footer/>}
        </Layout>
      </Layout>
      </PayPalScriptProvider>
      </div>
  );
}

export default class App extends Component {
  render() {
    return (
      <AppLayout />
    );
  }
}
//<PayPalScriptProvider options={{"clientId":"AUI9Am98jX9Zx938aMKooTPrLVeOY9ICfid6ubytQkUbR2E5lZSUGq_kx4sr9F_6MMUoVKuzbb4IrGMv"}}> 
//<PayPalScriptProvider options={{"clientId":"ATgZQJB0BCZN3lm7s7gX-jXOOBgV2_1iJS9pexML8uxDab8ibwnOVY6i2iKHmnWwv0nswwFwpiRTfDud"}}>
//sb-v1cca6721588@personal.example.com
//0f_t}Jk(
